import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'app-home-organization',
  templateUrl: './home-organization.component.html',
  styleUrls: ['./home-organization.component.scss'],
})
export class HomeOrganizationComponent extends BaseComponent implements OnInit {
  public chartItens: any[] = [];

  ngOnInit() {
    if (!this.isLoggedIn) {
      this.router.navigate(['login']);
    }
    this.currentUser = this.auth.currentUserValue;
  }

  public get isLoggedIn(): boolean {
    return this.auth.isAuthenticated();
  }

  getChartData() {
    //@TODO buscar dados para o chart da organização
    this.chartItens = this.setChartDummyData();
  }
}
